/*
 *
 * PublicViewEvent
 *
 */

import React from 'react';

import { FONT_FACE } from 'fonts';
const loadFonts = () => {
  const head = document.getElementsByTagName('head')[0];
  const style = document.createElement('style');
  style.innerHTML = FONT_FACE;
  head.appendChild(style);
};

import { connect } from 'react-redux';

import { Helmet } from 'react-helmet';

import {
  CSSTransition
} from 'react-transition-group';


import throttle from 'helpers/throttle';
import loadSingleFont from 'helpers/loadSingleFont';

import makeSelectPublicViewEvent from './selectors';

import combineStyles from 'components/Templates/general/combineStyles';


import injectComponentIntoCache from 'helpers/injectComponentIntoCache';
import cloneDeep from 'helpers/cloneDeep';
import selectVenueById from 'helpers/selectVenueById';

import setLanguageContent from 'helpers/setLanguageContent';

import selectLinkedSection from 'helpers/selectLinkedSection';

import PublicViewEventWrapper from './styles/PublicViewEventWrapper';
import PublicViewEventWrapperNotFound from './styles/PublicViewEventWrapperNotFound';
import Progressbar from './styles/Progressbar';

import {
  setCurrentPage
} from './helpers';


window.componentsCache = {};
window.stylesCache = {};
window.customStylesCache = {};
window.pageCache = {};

export class PublicViewEvent extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  constructor() {
    super();

    this.pageRef = React.createRef();
    this._isMounted = false;

    this.setPageContent = this.setPageContent.bind(this);
    this.handlePageView =this.handlePageView.bind(this);
    this.getWindowSize = this.getWindowSize.bind(this);

    const getSize = this.getWindowSize(true, true);

    this.state = {
      windowWidth: getSize,
      pageContent: '',
      templateSchema: window.eventData && eventData.template.templateSchema ? eventData.template.templateSchema : '',
      currentOrganization: window.eventData && eventData.template.organizationData ? eventData.template.organizationData : '',
      currentPage: '',
      language: 'en',
      isLoading: true,
      hasContent: false,
      metaTitleState: ''
    };
  }


  setPageContent(pageRef, initial, handlePageView) {   

    const {
      isPreview,
      baseUrlTamplate,
      params      
    } = this.props;

    const {
      viewPort,
      templateSchema,
      currentPage,
      language,
      windowWidth
    } = this.state;
 
    if (!templateSchema || !currentPage || !this.pageRef) return;

    const {
      chapterSlug,
      pageSlug,
      secondSlug
    } = params;
  
    const {
      pages,
      agenda,
      presentations,
      navigations,
      streams,
      speakers,
      companies,
      venues,
      forms,
      savedSections,
      organizationId,
      templateId,
      title,
      dateFrom,
      dateTo,
      defaultVenue,
      logo,
      tickets,
      subscriptions,
      calendars,
      customStyles,
      faviconImage,
      dateToWithTime,
      dateFromWithTime
    } = templateSchema;
  
    const agendaData = {
      presentations: presentations,
      agenda: agenda,
    }
  
    if (!pages) return;
  

  
    const defaultValues = {
      title: title,
      dateFrom: dateFrom,
      dateTo: dateTo,
      dateToWithTime: dateToWithTime,
      dateFromWithTime: dateFromWithTime,
      timezone: templateSchema.timezone,
      twitterAccount: templateSchema.twitterAccount,
      facebookAccount: templateSchema.facebookAccount,
      linkedinAccount: templateSchema.linkedinAccount,
      instagramAccount: templateSchema.instagramAccount,
      slackAccount: templateSchema.slackAccount,
      city: templateSchema.city,
      isOnline: templateSchema.isOnline,
    };

    const selectVenue = defaultVenue ? selectVenueById(venues, defaultVenue) : '';
    if (selectVenue) defaultValues.defaultVenueData = selectVenue;

    let thisCurrentPage = {};

    if (pageCache && currentPage && pageCache[currentPage.pageId] && currentPage.slug !== 'speaker') {
      return this.setState(pageCache[currentPage.pageId], () => {
        if (handlePageView) handlePageView();
      });
    }

   
    let mapPages = pages.map(function (thisPage) {

      if (thisPage.pageId !== currentPage.pageId) return;

      const {
        sections
      } = thisPage;
  
      if (!sections) return;

      thisCurrentPage = thisPage;

      let currentNumber = 0;
  
      const mapSections = sections.map(function (section) {

        const thisSectionData = section;

        if (!thisSectionData || thisSectionData && thisSectionData.isSectionHidden || initial && currentNumber > 4) return;
        currentNumber = currentNumber + 1;

  
        const thisSectionSelect = selectLinkedSection(savedSections, thisSectionData.sectionIdLinked ? thisSectionData.sectionIdLinked : thisSectionData.sectionId, thisSectionData);
  
        const getSectionData = thisSectionSelect.section ? thisSectionSelect.section : thisSectionSelect;
        
        const ThisComponent = window.componentsCache[getSectionData.componentName];

        const setStyling = function fnSetStyling() {

          try {
  
            const awaitRequire = window.stylesCache[thisSectionSelect.componentName];

            if (!awaitRequire || !awaitRequire.default) return;
  
            let requireStyling = cloneDeep(awaitRequire.default);
        
            function customStylesSelect()  {
              try {
                if (getSectionData.disableCustomColors) {
                  const awaitCustom = window.customStylesCache[getSectionData.componentName];
                  if (!awaitCustom || !awaitCustom.default) return;
                  const getDefaultStylesForTemplate = cloneDeep(awaitCustom.default);
                  if (getDefaultStylesForTemplate) return getDefaultStylesForTemplate;
                }
                return customStyles;
              } catch(error) {
                console.log(error);
              }
            };
   
            requireStyling = combineStyles(requireStyling, getSectionData.styling, customStylesSelect());
  
            return requireStyling;
          } catch(e) {
            console.log(e);
          }
  
        }();


        const commonProps = {
          isPreview: isPreview,
          viewPort: viewPort,
          language: language,
          styling: setStyling,
          pages: pages,
          timezone: templateSchema.timezone,
          baseUrlTamplate: pageSlug === 'location' && secondSlug ? '/location/'+secondSlug : chapterSlug ? '/location/'+chapterSlug : baseUrlTamplate,
          logo: logo,
          params: params,
          savedSections: savedSections,
          windowWidth: windowWidth,
          faviconImage: faviconImage,
          viewRef: '#PublicViewEventWrapper-id',
        };

  
        const commonData = {
          componentPayload: getSectionData,
          styling:  setStyling,
          pageIdLinked: section.pageIdLinked,
          sectionIdLinked: section.sectionIdLinked,
          sectionId: section.sectionId,
          organizationId: organizationId,
          templateId: templateId,
          pageId: thisPage.pageId,
          customStyles: customStyles,
        };
  
  

        if (ThisComponent) {
  
          const {
            type
          } = thisSectionSelect;
  
  
          if (type === 'insights') {
            if (speakers && speakers.length) defaultValues.speakerLength = speakers.length;
            if (companies && companies.length) defaultValues.companiesLength = companies.length;
            if (agendaData && agendaData.agenda && agendaData.agenda.length) defaultValues.daysLength = agendaData.agenda.length;
            defaultValues.attendeesLength = speakers && speakers.length ? speakers.length : 0;
  
  
            defaultValues.attendeesLength = speakers && speakers.length ? speakers.length : 0;
  
            if (tickets && tickets.length) {
              for (let index = 0; index < tickets.length; index++) {
                const element = tickets[index];
                if (element.numberSold) defaultValues.attendeesLength = defaultValues.attendeesLength + element.numberSold;
              }
            }
          }


  
          return (   
            <ThisComponent.default
              commonProps={commonProps}
              commonData={commonData}
              agendaData={type === 'agenda' || type.toLowerCase() === 'miniagenda' || type === 'agendaStacked' || type === 'speaker' ? agendaData : null}
              presentations={type === 'speaker' ? presentations : null}
              tickets={type === 'tickets' ? getSectionData.tickets : null}
              ticketsData={type === 'tickets' || type === 'workshop' ? tickets : null}
              presentationsData={type === 'workshop' ? presentations : null}
              subscriptions={type === 'subscriptions' ? getSectionData.subscriptions : null}
              subscriptionsData={type === 'subscriptions' ? subscriptions : null}
              navigationId={type === 'navigation' ? getSectionData.navigationId : null}
              navigations={type === 'navigation' ? navigations : null}
              speakers={type === 'speakers' || type === 'agenda' || type.toLowerCase() === 'miniagenda' || type === 'speaker' || type === 'workshop'|| type === 'agendaStacked' ? speakers : null}
              companies={type === 'partners' || type === 'speakers' || type === 'agenda' || type.toLowerCase() === 'miniagenda'|| type === 'agendaStacked' ? companies : null}
              forms={type === 'form' ? forms : null}
              calendars={type === 'calendar' ? calendars : null}
              streams={type === 'stream' ? streams : null}
              venues={type === 'venue' ? venues : null}
              defaultVenue={type === 'venue' ? defaultVenue : null}
              key={`ThisComponent-${section.sectionId}`}
              defaultValues={defaultValues}
              viewRef={'#PublicViewEventWrapper-id'}
            />
          );
           
        }
      }).filter((a) => a);

      return mapSections;

    }).filter((a) => a);
    
    const isHome = thisCurrentPage.slug === '/' || !thisCurrentPage.slug;

    const getPageTitle = setLanguageContent(thisCurrentPage, thisCurrentPage.metaTitle || isHome ? 'metaTitle' : 'title');
    const metaTitle = setLanguageContent(templateSchema, 'metaTitle');

    
    let isSpeaker = '';

    if (chapterSlug === 'speaker' || pageSlug === 'speaker' || secondSlug === 'speaker') {

      for (let index = 0; index < speakers.length; index++) {
        const element = speakers[index];

        if (element.slug === secondSlug || element.slug === pageSlug || element.slug === chapterSlug) {
          isSpeaker = `${element.firstName ? element.firstName : ''} ${element.lastName ? element.lastName : ''} | `;
        }
      }
    }

    let metaTitleState;

    if (mapPages) mapPages = mapPages.filter((a) => a)[0];

    if (mapPages && mapPages.length > 0) {

      metaTitleState = isSpeaker + `${getPageTitle && !isHome ? getPageTitle+' | ' : '' }` + `${metaTitle ? metaTitle : setLanguageContent(templateSchema, 'title')}`;

      const contentData = (
        <>
          <Helmet
            title={metaTitleState}
            meta={[
              { name: 'description', content: thisCurrentPage.metaDescription ? thisCurrentPage.metaDescription : templateSchema.metaDescription},
            ]}
          />
          {mapPages}
        </>
      );

      
      if (initial) {
        setTimeout(() => {
          if (this._isMounted && !this.state.isLoading) this.setPageContent(pageRef);
        }, 300);
      }

      const stateData = {
        pageContent: contentData,
        isLoading: false,
        hasContent: true,
        metaTitleState: metaTitleState
      };

      if (!initial) pageCache[currentPage.pageId] = {
        pageContent: contentData,
        isLoading: false,
        hasContent: true,
        metaTitleState: metaTitleState
      };

      return this.setState(stateData, () => {
        if (handlePageView) handlePageView();
      });
    }

    this.setState({
      isLoading: false,
    });



  }


  async handlePageView(initial) {

    if (window.eventData) {
      const {
        params,
      } = this.props;

      const {
        currentPage,
        metaTitleState
      } = this.state;

      if (!currentPage) return;

      const {
        pageSlug
      } = params;

      const {
        template
      } = window.eventData;

      const {
        templateSchema,
        organizationData
      } = template;


      const thisPageSlug = pageSlug === 'location' ? '/' : pageSlug ? `/${pageSlug}` : '/';

      const thisPayload = {
        templateId: templateSchema.templateId,
        organizationId: organizationData.organizationId,
        domain: window.location.hostname,
        slug: thisPageSlug,
        pageId: currentPage.pageId
      };

      const deployEnv = process.env.ACARA_DEPLOY_ENV;

      const protocol = deployEnv === 'production' ?  'https://analytics.acara.io' : deployEnv === 'staging' ? 'https://staginganalytics.acara.io' : 'http://localhost:3000';

      if (typeof gtag === 'function') {
        gtag('event', 'page_view', {
          page_title: metaTitleState,
          page_location: location.href,
          page_path: window.location.pathname,
        });
      }
      if (typeof ga === 'function' && !initial) {


        if (dataLayer) {
          dataLayer.push({'event': 'PageView'});
        }
        
      }


      fetch(protocol+'/analytics', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        mode: 'cors',
        body: JSON.stringify(thisPayload)
      }).then(response => {
        return response.json().then(responseData => {
          return;
        });
      }).catch(function (err) {
        console.log(err);
      });

      if (window && window.customPageView && !window.customPageViewDisable) {
        return window.customPageView();
      }

    }

  }

  getWindowSize(initial, skipMount) {

    if (!this._isMounted && !skipMount) return;

    const windowWidthInner = window.innerWidth;

    let thisSize = '';

    if (windowWidthInner <= 600) {
      thisSize = '37_5';
    } else if (windowWidthInner <= 1228) {
      thisSize = '76_8';
    }

    if (initial && typeof initial === 'boolean') return thisSize;

    this.setState({
      windowWidth: thisSize
    })

  }




  
  async componentDidMount() {
    this._isMounted = true;

    loadFonts();

    if (window && window.eventData && window.eventData.template && window.eventData.template.templateSchema && window.eventData.template.templateSchema.styleName) {
      const getComponents = await injectComponentIntoCache(window.eventData.template.templateSchema.styleName);

    }


    const {
      params,
    } = this.props;

    const {
      pageSlug
    } = params;
    


    const thisPageSlug = pageSlug === 'location' ? '/' : pageSlug ? pageSlug : '/';

    const page = setCurrentPage(window.eventData, thisPageSlug); 


    if (window && window.eventData && window.eventData.template && window.eventData.template.templateSchema && window.eventData.template.templateSchema.customStyles) {
      loadSingleFont(window.eventData.template.templateSchema.customStyles.defaultFont);
      loadSingleFont(window.eventData.template.templateSchema.customStyles.mainFont);
    }

    window.urlSearchParams = {};

    const urlSearch = new URLSearchParams(window.location.search);
    if (urlSearch) {
      urlSearch.forEach(function (val, key) {
        if (key.includes('utm_')) window.urlSearchParams[key] = val;
      });
  
    }

    const getSize = this.getWindowSize(true);
    if (page) return this.setState({
      currentPage: page,
      isLoading: true,
      windowWidth: getSize
    }, () => {  
      this.setPageContent(this.pageRef, true, () => {
        return this.handlePageView(true);
      });
      
      window.addEventListener('resize', throttle(this.getWindowSize, 17));    
    });

    this.setState({
      currentPage: page,
      hasContent: false,
      isLoading: false
    });

  }

  componentDidUpdate(prevProps, prevState)  {

    if (!this._isMounted) return false;

    const {
      params,
    } = this.props;

    const {
      pageSlug,
      secondSlug
    } = params;

    const {
      windowWidth,
      currentPage
    } = this.state;

    const thisPageSlug = pageSlug === 'location' ? '/' : pageSlug ? pageSlug : '/';
    const isNewPage = currentPage && thisPageSlug !== currentPage.slug || prevProps.params.secondSlug && secondSlug !== prevProps.params.secondSlug;
    if (currentPage && (isNewPage || windowWidth !== prevState.windowWidth)) {
      const page = setCurrentPage(window.eventData, thisPageSlug); 

      if (page) return this.setState({
        currentPage: page,
        isLoading: isNewPage ? true : this.state.isLoading
      }, () => {

          
          this.setPageContent(this.pageRef, isNewPage, isNewPage ? this.handlePageView : null);
          this.pageRef.current.scrollTo(0, 0);        
          

 
      });

      this.setState({
        currentPage: page,
        hasContent: false,
        isLoading: false
      });
  
 
    }

  }


  componentWillUnmount() {
    this._isMounted = false;

    window.removeEventListener('resize', throttle(this.getWindowSize, 17));
  }

  render() {


    const {
      pageContent,
      templateSchema,
      isLoading,
      hasContent
    } = this.state;

    const { metaTitle } = templateSchema;

    return (
      <PublicViewEventWrapper ref={this.pageRef} id={'PublicViewEventWrapper-id'} defaultFont={templateSchema && templateSchema.customStyles && templateSchema.customStyles.defaultFont ? templateSchema.customStyles.defaultFont : null}>
        <CSSTransition in={isLoading}
          timeout={{
            appear: 0,
            enter: 500,
            exit: 1000,
          }}
          classNames={'Progressbar'}
        >
          <Progressbar />
        </CSSTransition>
        {templateSchema && templateSchema.templateId && pageContent || hasContent ? pageContent : isLoading ? '' : (
          <>
            <Helmet
              title={setLanguageContent(templateSchema, metaTitle ? 'metaTitle' : 'title')}
              meta={[
                { name: 'description', content: templateSchema.metaDescription },
              ]}
            />
            <PublicViewEventWrapperNotFound>{window.errorTextVar ? window.errorTextVar : '404 - Nothing here... :('} <br/><br/>Go back to <a href={'https://acara.io/'} rel={'noopener'} >Acara</a></PublicViewEventWrapperNotFound>     
          </>
        )}
      </PublicViewEventWrapper>
    );
  }
}

const mapStateToProps = makeSelectPublicViewEvent();

function mapDispatchToProps(dispatch) {
  return {
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicViewEvent);